import { MultiSelect } from 'primereact/multiselect';
import React, { useState, useEffect } from 'react';
import { classNames } from 'primereact/utils';

const MultiSelectDropdown = ({
    name,
    value,
    field,
    items,
    itemsFilter,
    label = null,
    disabled,
    placeholder = null,
    tabIndex = null,
    itemTemplate = null,
    handleInputChange = () => { },
    onValueChange = () => { },
    setValue = () => { },
    className = null,
    labelStyle = {},
    hidden = false,
    enable = true,
    styles = {}
}) => {

    const [filterFuncion, setFilterFuncion] = useState([]);

    useEffect(() => {
        if (itemsFilter) {
            setFilterFuncion(itemsFilter());
        } else {
            setFilterFuncion(items);
        }
    }, [items, itemsFilter]);

    return (
        <div className={classNames('MultiSelectContainer animate__animated animate__fadeIn' + name, { hidden: hidden })}>
            <span className='encabezado__contenido p-float-label MultiSelectDropdown d-flex'>
                <MultiSelect
                    id={name}
                    name={name}
                    value={value}
                    options={filterFuncion}
                    optionLabel={field}
                    itemTemplate={itemTemplate ?? ((e) => e[field])}
                    placeholder={placeholder}
                    className={classNames('multiselectInput col-12', className)}
                    onChange={(e) => {
                        handleInputChange(e);
                        onValueChange(e);
                        setValue(e.value);
                    }}
                    filter
                    disabled={!enable}
                    style={styles}
                    display="chip"
                />
                <label style={labelStyle}>{label ?? name}</label>
            </span>
        </div>
    );
};

export default MultiSelectDropdown;
